<template>
  <div class="index" @click="goNext()" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 class="animated bounceInLeft">我们的<span>伙伴</span></h3>
      <img class="index-bottom" src="https://cdn.hanlandglobal.com/h5-partner-bg.png" />
      <div class="icon-list">
        <img class="icon animated flipInY" :class="item.class" :style="{animationDuration: '3s',animationDelay:'0.5s' }" v-for="(item,index) in iconList" :key="index+200" :src="item.url" />
      </div>
      <img ref="gif" class="gif-img animated fadeIn" :src="gif" /> 
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import button_img from '../assets/image/button-bg.png'
import icon_img1 from '../assets/image/icon-1.png'
import icon_img2 from '../assets/image/icon-2.png'
import icon_img3 from '../assets/image/icon-3.png'
import icon_img4 from '../assets/image/icon-4.png'
import icon_img5 from '../assets/image/icon-5.png'
import icon_img6 from '../assets/image/icon-6.png'
import icon_img7 from '../assets/image/icon-7.png'
import icon_img8 from '../assets/image/icon8.png'
import icon_img9 from '../assets/image/icon-9.png'
import icon_img10 from '../assets/image/icon-10.png'
import icon_img11 from '../assets/image/icon-11.png'
import icon_img12 from '../assets/image/icon-12.png'
import icon_img13 from '../assets/image/icon-13.png'
import icon_img14 from '../assets/image/icon-14.png'
import icon_img15 from '../assets/image/icon-15.png'
import icon_img16 from '../assets/image/icon-16.jpg'
import icon_img17 from '../assets/image/icon-17.jpg'
import icon_img18 from '../assets/image/icon-18.png'
import icon_img19 from '../assets/image/icon-19.png'
import icon_img20 from '../assets/image/icon-20.png'
import gif from '../assets/image/shouzhi.gif'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,gif,
      button_img,
      iconList:[
        {url:icon_img1,},
        {url:icon_img2,},
        {url:icon_img3,},
        {url:icon_img4,},
        {url:icon_img5,},
        {url:icon_img6,},
        {url:icon_img7,},
        {url:icon_img8,},
        {url:icon_img9,},
        {url:icon_img10,},
        {url:icon_img11,},
        {url:icon_img12,},
        {url:icon_img13,},
        {url:icon_img14,},
        {url:icon_img15,},
        {url:icon_img16,},
        {url:icon_img17,},
        {url:icon_img18,},
        {url:icon_img19,},
        {url:icon_img20,},
      ]
    }
  },
  mounted(){

  },
  methods:{
    goNext(){
      this.$router.push('/contactUs')
    }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3{
  width: 80%;
  margin: 0 auto;
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align:right;
  letter-spacing: 1px;
  padding-top:1.6rem;
  padding-bottom: 0.6rem;
  span{
    font-size: 0.72rem;
  }
}
.index-bottom{
  width: 100%;
  height: 5.2rem;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.2;
}
.icon-list{
  display: flex;
  justify-content:space-around;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto;
}
.icon{
  width: 1.34rem;
  height: 1.34rem;
  margin-top: 0.28rem;
  border-radius: 0.18rem;
  opacity: 1;
}
.gif-img{
  position:absolute;
  width: 2.7rem;
  height: 1.98rem;
  z-index: 999;
  bottom: 0rem;
  right: 0.2rem;
  animation-delay: 0.8s; 
}
</style>
